import $ from "jquery";

const headerProgress = () => {

    const init = () => {
        setupElements();
        bindEvents();
        onLoad();
    };

    // Variables to store HTML elements
    let el = {};

    // Take all HTML elements
    const setupElements = () => {
        el = {
            fills: $(".site-header__progress-container-fill"),
            sections: [
                $("#section-intro")[0],
                $("#section-about-hannah")[0],
                $("#section-coaching-plans")[0],
                $("#section-why-it-works")[0],
                $("#section-lets-talk")[0]
            ],
            navSpans: $(".site-header__progress-container a"),
            logo: $("#logo-header"),
            logo_overlay: $("#logo-header+.overlay-img"),
            progressContainer: $("#progress-container"),
            line: $(".site-header__line"),
        };

        el.manualLogo = false;
        el.ticking = false;

        // Initialize outline heights for all .section-outline-vertical sections
        el.outlineHeights = [];
        $(".section-outline-vertical").each((i, section) => {
            const overlay = $(section).find(".mi-outline-vertical-overlay");
            el.outlineHeights[i] = overlay.length ? 100 : 0; // start full height
        });

        // Check if all elements are present
        if (!el.progressContainer.length || !el.logo.length || el.fills.length === 0) return;
    };

    // Update Logo position via span/tag a
    const updateLogoPosition = (activeIdx) => {
        const activeSpan = el.navSpans.eq(activeIdx);
        if (!activeSpan.length) return;

        const spanRect = activeSpan[0].getBoundingClientRect();
        const contRect = el.progressContainer[0].getBoundingClientRect();

        const logoLeft =
            spanRect.left - contRect.left +
            spanRect.width / 2 -
            el.logo.outerWidth() / 2;

        el.logo.css("left", logoLeft + "px");

        el.logo_overlay.css("left", logoLeft + "px");
    };

    // Handle Progress while scrolling
    const updateProgress = () => {
        const scroll = window.scrollY;
        const containerWidth = el.progressContainer.outerWidth();
        const midpoint = scroll + window.innerHeight / 2;

        let activeIndex = 0;

        // Determine the active section
        for (let i = 0; i < el.sections.length; i++) {
            const secStart = el.sections[i];
            if (!secStart) continue;

            const startTop = secStart.offsetTop;
            const endTop = el.sections[i + 1]
                ? el.sections[i + 1].offsetTop
                : startTop + secStart.offsetHeight;

            if (midpoint >= startTop && midpoint < endTop) {
                activeIndex = i;
                break;
            }
        }

        // Last section
        const lastSection = el.sections[el.sections.length - 1];
        if (lastSection) {
            const lastEnd = lastSection.offsetTop + lastSection.offsetHeight;
            if (midpoint >= lastEnd) {
                activeIndex = el.sections.length - 1;
            }
        }

        // Update progress bar width
        el.fills.each(function (i) {
            const fill = $(this)[0];
            const secStart = el.sections[i];
            const secEnd = el.sections[i + 1];

            if (!secStart) return;

            const startTop = secStart.offsetTop;
            const endTop = secEnd ? secEnd.offsetTop : startTop + secStart.offsetHeight;

            let progress = 0;

            if (i < activeIndex) progress = 1;
            else if (i === activeIndex) {
                progress = (scroll - startTop) / (endTop - startTop);
                progress = Math.max(0, Math.min(1, progress));
            }

            fill.style.width = progress * 100 + "%";

            const bar = fill.parentElement;
            bar.classList.toggle("active-start", progress > 0);
            bar.classList.toggle("active-end", progress >= 1);
        });

        // Update active tab
        el.navSpans.removeClass("active");
        el.navSpans.eq(activeIndex).addClass("active");

        // Logo follow progress (except manual)
        if (!el.manualLogo) {
            updateLogoSmooth(containerWidth);
        }
    };

    // Move the logo according to progress
    const updateLogoSmooth = (containerWidth) => {
        let totalProgress = 0;

        el.fills.each(function () {
            const w = parseFloat(this.style.width) || 0;
            totalProgress += w / 100 / el.fills.length;
        });

        let leftPos = (1 - totalProgress) * containerWidth;
        leftPos -= el.logo.outerWidth() / 2;

        const minLeft = 0;
        const maxLeft = containerWidth - el.logo.outerWidth();

        if (leftPos < minLeft) leftPos = minLeft;
        if (leftPos > maxLeft) leftPos = maxLeft;

        el.logo.css("left", leftPos + "px");
        el.logo_overlay.css("left", leftPos + "px");
    };


    const updateOutlinesSmooth = () => {
        const midpoint = window.scrollY + window.innerHeight / 2;
        const sections = $(".section-outline-vertical");

        sections.each((i, section) => {
            const overlay = $(section).find(".mi-outline-vertical-overlay");
            if (!overlay.length) return;

            const secStart = section.offsetTop;
            const secEnd = sections[i + 1] ? sections[i + 1].offsetTop : secStart + section.offsetHeight;

            const secHeight = secEnd - secStart;

            const threshold = secStart + secHeight * 0.2;

            let target = 100;

            if (midpoint >= threshold && midpoint < secEnd) {
                target = 100 - ((midpoint - threshold) / (secEnd - threshold)) * 100;
            } else if (midpoint >= secEnd) {
                target = 0;
            }

            if (el.outlineHeights[i] === undefined) el.outlineHeights[i] = 100;
            el.outlineHeights[i] += (target - el.outlineHeights[i]) * 0.1;

            overlay.css("height", el.outlineHeights[i] + "%");
        });

        requestAnimationFrame(updateOutlinesSmooth);
    };


    //  Events (click, scroll, load)
    const bindEvents = () => {

        // Click navigation → scroll to section
        $(document).on("click", ".site-header__progress-container a", function () {
            const idx = parseInt($(this).data("index")) - 1;
            const target = $(`#section-${idx + 1}`);

            if (target.length) {

                const headerOffset = 85; // header height
                const targetPos = target.offset().top - headerOffset;

                window.scrollTo({
                    top: targetPos,
                    behavior: "smooth"
                });
            }

            el.manualLogo = true;
            updateLogoPosition(idx);

            setTimeout(() => (el.manualLogo = false), 500);
        });

        // Scroll
        $(window).on("scroll", () => {
            if (!el.ticking) {
                window.requestAnimationFrame(() => {
                    updateProgress();
                    el.ticking = false;
                });
                el.ticking = true;
            }
        });
    };

    //  Load init
    const onLoad = () => {
        $(window).on("load", () => {
            setTimeout(() => {
                updateProgress();
                updateLogoPosition(0);
                updateOutlinesSmooth();
            }, 100);
        });
    };


    init();
};

try {
    headerProgress();
} catch (error) {
    console.error("headerProgress: ", error);
}
